import * as React from 'react'
import {translateCountryName} from "@ui-seeker/utils";

import {LabelCountry} from "@components";

export default function countryColumn() {
	return {
		name: 'country', label: 'Market',
		options: {
			customBodyRowRender: (value) => {
				return <LabelCountry country={value} label={translateCountryName(value)} />
			}
		}
	}
}